/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Copy(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    id='svg_11'
                    stroke='null'
                >
                    <g
                        fill='none'
                        fillRule='evenodd'
                        id='svg_6'
                        transform='matrix(0.9543540543904991,0,0,0.9509267734314328,2.639542227200508,5.819755026065549) '
                    >
                        <g
                            fillRule='nonzero'
                            id='svg_7'
                            stroke={iconColor || '#000'}
                        >
                            <g
                                id='svg_8'
                                stroke='null'
                            >
                                <path
                                    d='m17.117474,13.80609l4.15803,0c0.00705,0 0.01588,-0.0088 0.01588,-0.01588l0,-18.79433c0,-0.00705 -0.00879,-0.01588 -0.01588,-0.01588l-18.79433,0c-0.00704,0 -0.01588,0.00879 -0.01588,0.01588l0,4.15803l-4.15698,0c-0.01275,0 -0.01693,0.00421 -0.01693,0.01588l0,18.79433c0,0.00705 0.00879,0.01588 0.01588,0.01588l18.79433,0c0.00682,0 0.01588,-0.00904 0.01588,-0.01693l0,-4.15698zm-14.6363,0l14.59282,0l0,4.13043l-18.73913,0l0,-18.73913l4.13043,0l0,14.59282c0,0.00704 0.0088,0.01588 0.01588,0.01588zm18.76673,-18.78261l0,18.73913l-18.73913,0l0,-18.73913l18.73913,0z'
                                    id='svg_10'
                                    stroke='null'
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}